import React, {useState, useEffect} from 'react';
import { Drawer, Button, TextField, Typography, makeStyles, Select, FormControl, InputLabel, Grid, Divider, CircularProgress, Tooltip } from '@material-ui/core';
import UserManagementPageApis from "../services/UserManagementPageServices";
import HeaderApi from "../../../common-components/header/services/header-apis";
import Options from "../../../globalization/userPreferences-code.json";
import CountryCode from "../../../globalization/country-code";
import ExpandMoreStyledIcon from "../../../common-components/expandMoreStyledIcon/expandMoreStyledIcon";
const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    width: window.innerWidth/2.8,
    padding: theme.spacing(5),
  },
  formField: {
    marginBottom: theme.spacing(2),
    backgroundColor: 'white', // Same background color as in LogIn component
    width: 300
  },
  drawerHeader: {
    marginBottom: theme.spacing(1),
  },
  partDetails: {
  color: '#194cab',
  opacity: 1,
  fontFamily: 'Barlow',
  fontSize: 22,
  },
  partDetailsDisabled: {
    color: 'gray',
    opacity: 1,
    fontFamily: 'Barlow',
    fontSize: 22,
    },
  partSubDetails: {
    color: '#b9b8b8',
    opacity: 1,
    fontWeight: 400,
    fontSize: 14,
    letterSpacing: 0.14,
    fontStyle: 'italic',
  },
  proceed: {
    "&:hover": {
      opacity: 1,
    },
    background:
      "transparent linear-gradient(90deg, #0055A4 0%, #0079E6 100%) 0% 0% no-repeat padding-box",
    borderRadius: 15,
    font: 'Barlow',
    opacity: .8,
    fontWeight: 500,
    color: "#FFFFFF",
    boxShadow: "none",
  },
  cancelButton: {
    marginTop: theme.spacing(1),
    background: "transparent linear-gradient(90deg, #bebfc046 0%, #bebfc046 100%) 0% 0% no-repeat padding-box",
    borderRadius: 15,
    font: "Barlow",
    opacity: 0.8,
    fontWeight: 500,
    color: "#FFFFFF",
    boxShadow: "none",
  },
}));

const CreateEditUserDrawer = ({ open, onClose }) => {
  const userManagementPageApi = new UserManagementPageApis();
  const headerApi = new HeaderApi();
  const classes = useStyles();
  const userAccountInfo = JSON.parse(localStorage.getItem('accountInfo'));
  const [userInfo, setUserInfo] = useState({
    username: '',
    password: '',
    email: '',
    firstName: '',
    middleName: '',
    lastName: '',
    phoneNumber: '',
    userRole:"EMTUSER",
    updatedDate:'',
    countryCode:'+1',
    userLanguage: "en-us",
    userMeasurementSystemValue: 'imperial',
    userPressureUnit: 'KPA',
    logoLocation: '',
    lastAccessedAccountId: "",
    lastAccessedLocationId: "",
    lastAccessedAccountName: "",
    lastAccessedLocationName: ""
  });
  const [loading, setLoading] = useState(false);
  const [isDisable, setDisable] = useState(true);
  const [optionRoles, setOptionRoles] = useState([]);

  useEffect(() => {
    if (userAccountInfo?.userProfile?.userRole !== 'EMTCADMIN') {
      userManagementPageApi.getRoles().then((data) => {
      setOptionRoles(data);
      })
    }
    else {
    setOptionRoles(['EMTUSER', 'EMTVO'])
  }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect (() => {
    formCheck();
  }, [userInfo])

  
  const removeDuplicates =(arr) => {
    return arr.filter((value, index, self) =>
    index === self.findIndex((t) => (
      t.countryCode === value.countryCode
    )))
  }

  const nonDuplicateCountryCode = removeDuplicates(CountryCode);
  const countriesList =
    nonDuplicateCountryCode.length > 0 &&
    nonDuplicateCountryCode.map((item) => {
      if (userInfo.countryCode === item.countryCode) {
        return (
          <option key={item.countryCode} value={item.countryCode} selected>
            {item.areaName}
          </option>
        );
      } else {
        return (
          <option key={item.countryCode} value={item.countryCode}>
            {item.areaName}
          </option>
        );
      }
    });

  const saveUser = () => {
    setLoading(true);
    let date = new Date();

    let loginInfo = {
      username: userInfo.username,
      password: userInfo.password,
      email: userInfo.email
    }
    userManagementPageApi.createUserLogin(loginInfo).then((response) => {

      if (response.status === 400) {
        alert(`${response?.data?.errors[0]?.description}`);
        setLoading(false);
      } else if (response.status === 200 || response.message.includes("success")) {
        let userProfileInfo = {
          userId: userInfo.username,
          firstName: userInfo.firstName,
          middleName: userInfo.middleName,
          lastName: userInfo.lastName,
          userRole: userInfo.userRole,
          updatedDate:  date.toISOString(),
          phoneNumber: userInfo.phoneNumber,
          countryCode: userInfo.countryCode,
        };
        userManagementPageApi.createUserProfile(userProfileInfo).then((response) => {
          if (response.status === 400) {
            alert(`${response?.data?.errors[0]?.description}`);
            setLoading(false);
          } else if (response.status === 200 || response.message.includes("success")) {
            let accountInfo = JSON.parse(localStorage.getItem('accountInfo'));
            let userPreferenceInfo = {
              updatedBy: accountInfo?.userProfile?.userId,
              userId: userInfo.username,
              userLanguage: userInfo.userLanguage,
              userMeasurementSystemValue: userInfo.userMeasurementSystemValue,
              userPressureUnit: userInfo.userPressureUnit,
              logoLocation: "https://emtrackprodstorage.blob.core.windows.net/emtrack-prod-blob-container/Logo_0_1724933369402.pn",
              updatedDate: date.toISOString(),
              lastAccessedAccountId: accountInfo?.account?.accountId,
              lastAccessedLocationId: accountInfo?.location[0]?.value,
              lastAccessedAccountName: accountInfo?.account?.accountName,
              lastAccessedLocationName: accountInfo?.location[0]?.label,
            
            }
            userManagementPageApi.createUserPreference(userPreferenceInfo).then((response) => {
               
              if (response.status === 200 || response.message.includes("success")) {
                let userRoleInfo = {
                  roleName: userInfo.userRole,
                  username: userInfo.username
                }
                userManagementPageApi.assignRole(userRoleInfo).then((response)=> {
                  if (response?.status === 400) {
                    alert(`${response?.data?.errors[0]?.description}`);
                    setLoading(false);
                  } else if (response.status === 200 || response.message.includes("success")) {

                    if (userAccountInfo?.userProfile?.userRole === 'EMTCADMIN') {
                        let data = {
                          username: userInfo.username,
                        }
                        userManagementPageApi.assignGrandparentAccount(data).then((response) => {
                          if (response?.status === 200 || response.message.includes("successfully")) {
                            alert('Account created successfully!');
                            setLoading(false);
                            onClose(); 
                            window.location.reload();
                          } else {
                            alert(`${response?.data?.message}. Please contact EmTrack support team.`);
                          }
                        })
                    } else {
                      alert('Account created successfully!');
                      setLoading(false);
                      onClose(); 
                      window.location.reload();
                    }

                    
                  } else return;
                })
              } else if (response?.status === 400) {
                alert(`${response?.data?.errors[0]?.description}`);
                setLoading(false);
              } else return;
            })
          } else return;
        });

      } else return;
    })







}


  let roles =
  optionRoles.length > 0 &&
  optionRoles.map((role, i) => {
    if (userAccountInfo?.userProfile?.userRole === 'EMTCADMIN') {

      if (role === 'EMTUSER' || role === 'EMTVO') {
        return (
          <option key={role} value={role}>
            {role}
          </option>
        );
      }
    } else {
      return (
        <option key={role} value={role}>
          {role}
        </option>
      );
    }
  }, this);

  let language =
  Options.userLanguage.length > 0 &&
  Options.userLanguage.map((item, i) => {
    return (
      <option key={item.value} value={item.value}>
        {item.text}
      </option>
    );
  }, this);

let pressure =
  Options.userPressureUnit.length > 0 &&
  Options.userPressureUnit.map((item, i) => {
    return (
      <option key={item.value} value={item.value}>
        {item.text}
      </option>
    );
  }, this);

let measurementSystem =
  Options.userMeasurementSystemValue.length > 0 &&
  Options.userMeasurementSystemValue.map((item, i) => {
    return (
      <option key={item.value} value={item.value}>
        {item.text}
      </option>
    );
  }, this);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserInfo({ ...userInfo, [name]: value });
  };


  const formCheck = () => {

    const hasLetters = (myString) => {
    let regExp = /[a-z]/i;
    let hasLetters = regExp.test(myString)
    return hasLetters;
    }
    if (userInfo.username.length > 0 && hasLetters(userInfo.username) &&
      userInfo.password.length > 0 && hasLetters(userInfo.password) &&
      userInfo.email.length > 0 &&  hasLetters(userInfo.email) && userInfo.email?.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/) &&
      userInfo.firstName.length > 0 && hasLetters(userInfo.firstName) &&
      userInfo.lastName.length > 0 && hasLetters(userInfo.lastName)) {
        setDisable(false);
    } else setDisable(true);
  }

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      classes={{ paper: classes.drawerPaper }}
    >
      <Grid container>
        <Grid item sm={12}>
          <Typography variant="h5" className={classes.partDetails}>
            LOGIN INFO
          </Typography>
        </Grid>
        <Grid item sm={12}>
        <span style={{fontStyle:'italic', color:'grayText'}} className={classes.partSubDetails}>Input your login credentials that will be used in next time you login.</span>
        </Grid>
        <Grid item sm={12} style={{marginTop:15}}>
          <TextField
          autoFocus
          margin="dense"
          name="username"
          label="Username"
          type="text"
          value={userInfo.username}
          onChange={handleChange}
          className={classes.formField}
          variant="outlined"
          style={{marginRight:40}}
        />
        <Tooltip title="Password must at least 6 characters consist of alphanumeric with a capital letter, small letter and special character.">

          <TextField
            margin="dense"
            name="password"
            label="Password"
            type="password"
            value={userInfo.password}
            onChange={handleChange}
            className={classes.formField}
            variant="outlined"
          />
        </Tooltip>
        </Grid>
        <Grid item sm={12}>
        <FormControl variant="outlined" className={classes.formField} style={{marginTop:10}}>
        <InputLabel id="user-measurement-system-label">User Role</InputLabel>
        <Select
            native
            label="User Role"
            className="sub-edit-textbox"
            IconComponent={ExpandMoreStyledIcon}
            value={userInfo.userRole}
            name="userRole"
            onChange={handleChange}
          >
            {roles}
          </Select>
          </FormControl>
        </Grid>

        <Grid item sm={12} style={{marginTop:30}}>
          <Typography variant="h5" className={classes.partDetails}>
            PERSONAL DETAILS
          </Typography>
        </Grid>
        <Grid item sm={12}>
        <span style={{fontStyle:'italic', color:'grayText'}} className={classes.partSubDetails}>This will be used as your profile when using the application.</span>
        </Grid>
        <Divider style={{marginTop:15}} light />
        <Grid item sm={12} >
        
              <TextField
                margin="dense"
                name="firstName"
                label="First Name"
                type="text"
                value={userInfo.firstName}
                onChange={handleChange}
                className={classes.formField}
                variant="outlined"
                style={{marginRight:40}}
              />
              <Tooltip title="Remember to put @ and domain(e.g. .com)">
                <TextField
                  margin="dense"
                  name="email"
                  label="Email"
                  type="email"
                  value={userInfo.email}
                  onChange={handleChange}
                  className={classes.formField}
                  variant="outlined"
                />
              </Tooltip>
        </Grid>
        <Grid item sm={12}>
          <TextField
            margin="dense"
            name="middleName"
            label="Middle Name"
            type="text"
            value={userInfo.middleName}
            onChange={handleChange}
            className={classes.formField}
            variant="outlined"
            style={{marginRight:40}}
          />
           <TextField
                margin="dense"
                name="phoneNumber"
                label="Phone Number"
                type="text"
                value={userInfo.phoneNumber}
                onChange={handleChange}
                className={classes.formField}
                variant="outlined"
              />
         

        </Grid>
        <Grid item sm={12}>
        <TextField
            margin="dense"
            name="lastName"
            label="Last Name"
            type="text"
            value={userInfo.lastName}
            onChange={handleChange}
            className={classes.formField}
            variant="outlined"
            style={{marginRight:40}}
          />
            <FormControl variant="outlined" className={classes.formField} style={{marginTop:10}}>
              <InputLabel id="user-language-label">Country</InputLabel>
              <Select
                 native
                 className="sub-edit-textbox"
                 variant="outlined"
                 value={userInfo.countryCode}
                 IconComponent={ExpandMoreStyledIcon}
                 onChange={handleChange}
                 name="countryCode"
               >
                 {countriesList}
              </Select>
          </FormControl>
        </Grid>
        <Grid item sm={12} style={{marginTop:30}}>
          <Typography variant="h5" className={classes.partDetails}>
            USER PREFERENCE
          </Typography>
        </Grid>
        <Grid item sm={12}>
        <span style={{fontStyle:'italic', color:'grayText'}} className={classes.partSubDetails}>This part set your initial preferences related to the application.</span>
        </Grid>
        <Grid item sm={12}  style={{marginTop:15}}>
          <FormControl variant="outlined" className={classes.formField} style={{marginTop:10}}>
          <InputLabel id="user-language-label">User Language</InputLabel>
          <Select
            native
            label="User Language"
            className="sub-edit-textbox"
            IconComponent={ExpandMoreStyledIcon}
            value={userInfo.userLanguage}
            name="userLanguage"
            onChange={handleChange}
          >
            {language}
          </Select>
        </FormControl>
        </Grid>
        <Grid item sm={12}>
          <FormControl variant="outlined" className={classes.formField} style={{marginTop:10}}>
            <InputLabel id="user-measurement-system-label">Measurement System</InputLabel>
            <Select
              native
              label="Measurement System"
              className="sub-edit-textbox"
              IconComponent={ExpandMoreStyledIcon}
              value={userInfo.userMeasurementSystemValue}
              name="userMeasurementSystemValue"
              onChange={handleChange}

            >
              {measurementSystem}
            </Select>
          </FormControl>

        </Grid>
        <Grid item sm={12}>
          <FormControl variant="outlined" className={classes.formField} style={{marginTop:10}}>
            <InputLabel id="user-pressure-unit-label">Pressure Unit</InputLabel>
            <Select
              native
              label="Pressure Unit"
              className="sub-edit-textbox"
              IconComponent={ExpandMoreStyledIcon}
              name="userPressureUnit"
              value={userInfo.userPressureUnit}
              onChange={handleChange}
              style={{marginTop:10}}
            >
              {pressure}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      {loading ? <CircularProgress size={30} color="inherit" /> :
        <>
          <Button
            onClick={saveUser}
            color="primary"
            variant="contained"
            disabled={isDisable}
            className={isDisable? classes.cancelButton : classes.proceed}
            style={{ marginTop: 40 }}
          >
            Create
          </Button>
          <Button
            onClick={onClose}
            color="secondary"
            variant="contained"

            className={classes.cancelButton}
          >
            Cancel
          </Button>
        </>
      }
    </Drawer>
  );
};

export default CreateEditUserDrawer;